<template>
    <b-modal
        id="add-folder-modal"
        v-model="modal"
        title="Nieuwe map"
        :ok-disabled="!name"
        ok-title="Opslaan"
        cancel-title="Annuleren"
        modal-class="apprentice-default-modal"
        cancel-variant="outline-primary"
        @ok="onOk()"
        @keydown.native.enter="onEnter()">
        <b-form-group
            label="Map naam"
            label-for="add-folder-name">
            <b-form-input
                id="add-folder-name"
                v-model="name"
                trim
                type="text"
                placeholder="Vul hier de gewenste naam in">
            </b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
//Todo: update
export default {
    name: 'design-2021-edit-presentation-folder-modal-component',
    data() {
        return {
            name: '',
            modal: false,
            folder: null,
        };
    },
    methods: {
        show(folder) {
            this.folder = folder;
            this.name = folder.name;
            this.modal = true;
        },
        onOk() {
            let data = {
                name: this.name,
            };
            this.alert.saving();
            this.axios.post(this.routes.presentationFolderUpdate(this.folder.id), data).then(
                (response) => {
                    this.$emit('data-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
            this.$emit('folder-added', this.name);
            this.name = '';
        },
        onEnter() {
            this.$refs['add-folder-modal'].hide();
            this.onOk();
        },
    },
};
</script>

<style scoped></style>
